import { formatDate, NgIf, AsyncPipe, CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { AsamcoAuthService } from '@asamco/base';
import { User, UserService } from '@asamco/user-management/shared';
import { pathJoin, skipAuthInterceptor } from '@asamco/utils';
import { BehaviorSubject, combineLatest, from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PrettyJsonViewerComponent } from '../../integration-tester/pretty-json-viewer/pretty-json-viewer.component';
import { AuditLogData } from '../../interfaces/audit-log-data.interface';
import { Company } from '../../interfaces/company.interface';
import { LinkTemplate } from '../../interfaces/link-template.interface';
import { LinkType } from '../../interfaces/link-type.interface';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { LinkTemplateService } from '../../services/link-template.service';
import { LinkTypeService } from '../../services/link-type.service';
import { LinkService } from '../../services/link.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoSummaryModule, DxiGroupItemModule, DxiSortByGroupSummaryInfoModule, DxiColumnModule, DxoSelectionModule, DxoSearchPanelModule, DxoPagingModule, DxoGroupPanelModule, DxoGroupingModule } from 'devextreme-angular/ui/nested';
import { DxButtonModule, DxDataGridModule, DxTextBoxModule } from 'devextreme-angular';
import { ApplicationInsightsService } from '../../services/application-insights.service';
import DevExpress from 'devextreme';
import { DxDataGridComponent, DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import ODataStore from 'devextreme/data/odata/store';

@Component({
    selector: 'app-shell-admin-financial-issues-overview',
    templateUrl: './admin-financial-issues-overview.component.html',
    styleUrls: ['./admin-financial-issues-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
		CommonModule,
        DxDataGridModule,
        DxoSummaryModule,
        DxiGroupItemModule,
        DxiSortByGroupSummaryInfoModule,
        DxiColumnModule,
        DxTemplateModule,
        NgIf,
		DxTextBoxModule,
        DxoSelectionModule,
        DxoSearchPanelModule,
        DxoPagingModule,
        DxoGroupPanelModule,
        DxoGroupingModule,
		DxButtonModule,
        PrettyJsonViewerComponent,
        AsyncPipe,
    ],
})
export class AdminFinancialIssuesOverviewComponent implements OnInit {
	@ViewChild('picklistcomponent', { static: false }) prettyJsonComponentpicklist: PrettyJsonViewerComponent;
	@ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;

	public jobLogSourceOData: ODataStore<any[]> = null;

	public adminInstanceLog: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

	traceparentInfo$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

	stateSortOrder: string;

	traceparentid: string;

	constructor(
		@Inject(LOCALE_ID) private locale: string,
		private linkService: LinkService,
		private userService: UserService,
		private companyService: SelectedCompanyService,
		private auth: AsamcoAuthService,
		private linkTemplateService: LinkTemplateService,
		private linkTypeService: LinkTypeService,
		private http: HttpClient,
		private applicationInsightsService: ApplicationInsightsService,
		private asamcoAuthService: AsamcoAuthService
	) {}

	ngOnInit(): void {
		this.stateSortOrder = 'desc';
		this.asamcoAuthService.authTokenChanged$.subscribe(
			(token) => {
				if (token.token) {
					// Setup your data source
					this.jobLogSourceOData = new ODataStore<any[]>({
						deserializeDates: false,
						url: this.asamcoAuthService.userSession.backend.odataBaseUrl + 'JobLogAdminInsights',
						version: 4,
						beforeSend: (e) => {
							e.headers = {
								"Authorization": `Bearer ${token.token}`,
							};
						}
					});
				}
			},
			(error) => {
				console.error('Error fetching the token:', error);
			}
		);
	}

	lastGroupKey: string | null = null;

	shouldShowGroupHeader(rowIndex: number): boolean {
	const gridInstance = this.grid?.instance;
	if (!gridInstance) return false;

	const row = gridInstance.getVisibleRows()[rowIndex];
	if (!row || !row.data) return false;

	const currentKey = row.data.sessionIdentifier;

	if (currentKey !== this.lastGroupKey) {
		this.lastGroupKey = currentKey;
		return true;
	}

	return false;
	}

	logObject(e: any) {
		console.log(e);
	}

	sendTraceparentid(e: any)
	{
		this.applicationInsightsService.getTraceparentInfo(this.traceparentid).subscribe(e => {
			this.traceparentInfo$.next(e);
		})
	}

	onCellClick(e: DxDataGridTypes.CellClickEvent)
	{
		console.log(e.value)
		navigator.clipboard.writeText(e.value).then(() => {
			console.log('Copied to clipboard');
		  }).catch(err => {
			console.error('Failed to copy: ', err);
		  });
	}

	padGroupingText(obj: any): string {
		const dataObj = obj.data;
		if (!dataObj) return '';

		const date = `[${formatDate(dataObj.creationDate, 'dd/MM/yyyy HH:mm', this.locale)}]`;
		const companyIdentifier = `[${dataObj.fullCompanyIdentifier}]`;
		const from = dataObj.fromLinkTemplateDescription;
		const to = dataObj.toLinkTemplateDescription;
		const link = `[${dataObj.linkName}]`;
		const issueCount = dataObj.issueCount || 1;
		const issueString = issueCount === 1 ? 'issue' : 'issues';

		return `${date} ${companyIdentifier} - ${link} - ${from} - ${to} - [${issueCount} ${issueString}]`;
	  }

	// padGroupingText(obj: any) {
	// 	let dataObj = null;
	// 	let issueCount: number = 0;
	// 	let issueString = 'issue';
	// 	if (obj.data?.collapsedItems) {
	// 		dataObj = obj.data.collapsedItems[0];
	// 		issueCount = obj.data.collapsedItems.length;
	// 	} else if (obj.data?.items) {
	// 		dataObj = obj.data.items[0];
	// 		issueCount = obj.data.items.length;
	// 	}

	// 	let date: string = '[' + formatDate(dataObj.creationDate, 'dd/MM/yyyy HH:mm', this.locale) + ']';
	// 	let companyIdentifier: string = '[' + dataObj.fullCompanyIdentifier + ']';
	// 	let fromLinkTemplateDescription: string = dataObj.fromLinkTemplateDescription;
	// 	let toLinkTemplateDescription: string = dataObj.toLinkTemplateDescription;
	// 	let linkName: string = '[' + dataObj.linkName + ']';

	// 	if (issueCount > 1) {
	// 		issueString = 'issues';
	// 	}
	// 	let fullString: string =
	// 		date +
	// 		' ' +
	// 		companyIdentifier +
	// 		' - ' +
	// 		linkName +
	// 		' - ' +
	// 		fromLinkTemplateDescription +
	// 		' - ' +
	// 		toLinkTemplateDescription +
	// 		' - ' +
	// 		'[' +
	// 		issueCount +
	// 		' ' +
	// 		issueString +
	// 		']';
	// 	return fullString;
	// 	//| date:'d/MM/yyyy H:mm' }}] - [{{obj.data.collapsedItems[0].fullCompanyIdentifier}}] {{obj.data.collapsedItems[0].fromLinkTemplateDescription}} - {{obj.data.collapsedItems[0].toLinkTemplateDescription}}
	// 	return 'ok';
	// }

	openAzureHistoryIfExists(data: any) {
		console.log(data.row.data);
		this.linkService.GetFunctionAppInstanceHistory(data.row.data.linkId, data.row.data.instanceId).subscribe(e => {
			this.adminInstanceLog.next(e);
			this.prettyJsonComponentpicklist.toggleModal(true);
		});
	}

	calculateCellValue(rowData: any) {
		return rowData.id;
	}
}
